<adapt-menu [items]="menuItems"></adapt-menu>
